const LinkedIn = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 4H23C25.762 4 28 6.239 28 9V23C28 25.761 25.762 28 23 28H9C6.239 28 4 25.761 4 23V9C4 6.239 6.239 4 9 4ZM12 23V12H9V23H12ZM10.5 10C9.672 10 9 9.32823 9 8.5C9 7.67177 9.672 7 10.5 7C11.328 7 12 7.67177 12 8.5C12 9.32823 11.3289 10 10.5 10ZM21 23H24V16.241C24 10.988 18.396 11.179 17 13.765V12H14V23H17V17.396C17 14.283 21 14.028 21 17.396V23Z"
      fill="#0966C1"
    />
  </svg>
);

export default LinkedIn;
